import { Injectable } from '@angular/core';
import { isPlatform } from '@ionic/angular';
import { MobileDevices, MobilePlatforms } from 'src/app/core/contracts';

@Injectable({ providedIn: 'root' })
export class MobilePlatform {
  readonly platform: MobilePlatforms;
  readonly device: MobileDevices;
  readonly isNative: boolean;
  readonly isTablet: boolean;
  readonly isIpad: boolean;
  readonly isHuawei: boolean;

  constructor() {
    const ua = navigator.userAgent?.toLowerCase() ?? '';
    this.isHuawei = ua.indexOf('huawei') !== -1;
    this.isNative = isPlatform('capacitor');
    this.isTablet = isPlatform('tablet');
    this.isIpad = isPlatform('ipad');
    this.platform = this.detectPlatform();
    this.device = this.detectDevice();
  }

  private detectPlatform(): MobilePlatforms {
    if (!this.isNative) {
      return MobilePlatforms.Web;
    }
    if (isPlatform('ios')) {
      return MobilePlatforms.Ios;
    }
    if (isPlatform('android')) {
      return this.isHuawei ? MobilePlatforms.Huawei : MobilePlatforms.Android;
    }
    return MobilePlatforms.Web;
  }

  private detectDevice(): MobileDevices {
    if (this.isIpad) {
      return MobileDevices.Ipad;
    }
    if (isPlatform('iphone') || isPlatform('ios')) {
      return MobileDevices.Iphone;
    }
    if (this.isHuawei) {
      return this.isTablet ? MobileDevices.HuaweiTablet : MobileDevices.Huawei;
    }
    if (isPlatform('android')) {
      return this.isTablet ? MobileDevices.AndroidTablet : MobileDevices.Android;
    }
    return MobileDevices.Desktop;
  }
}
